import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const initials = (u) => (u.name || u.email || "?").split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const UserAvatar = ({ user, className = "h-9 w-9", testid = "user-avatar" }) => (
  <Avatar className={className} data-testid={testid}>
    {user.picture && <AvatarImage src={user.picture} alt={user.name || "Profile photo"} />}
    <AvatarFallback className="bg-slate-200 text-xs font-semibold text-slate-700">{initials(user)}</AvatarFallback>
  </Avatar>
);
